import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="w-full px-6 md:px-8 py-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl font-bold text-foreground-950 mb-6 text-center" style={{ fontFamily: 'var(--font-heading)' }}>
          浏览分类
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300/50 hover:bg-primary-50/30 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-bold text-foreground-950 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-400 text-center">{cat.description}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}